// @/context/CursorContext.js
import React, { createContext, useState, useContext } from "react";

const CursorContext = createContext();

export const useCursor = () => {
  return useContext(CursorContext);
};

export const CursorProvider = ({ children }) => {
  const [cursorVariant, setCursorVariant] = useState("default");
  const [cursorText, setCursorText] = useState("");

  return (
    <CursorContext.Provider
      value={{ cursorVariant, setCursorVariant, cursorText, setCursorText }}
    >
      {children}
    </CursorContext.Provider>
  );
};
